import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivityEvent } from '../../models/activityEvent';
import { Participant } from '../../models/participant';
import { LampService } from '../../services/lamp.service';

@Component({
  selector: 'app-participant-activities-detail',
  templateUrl: './participant-activities-detail.component.html',
  styleUrls: ['./participant-activities-detail.component.scss']
})
export class ParticipantActivitiesDetailComponent implements OnInit {
  participant: Participant;
  activity: string;
  startDate: Date = new Date();
  endDate: Date = new Date();
  index: number;
  loading: boolean = false;
  showTable: boolean = false;
  normalize: boolean = false;
  date: Date = new Date();
  displayedColumns = ['timestamp', 'score', 'value'];
  dataSource: MatTableDataSource<ActivityEvent> = new MatTableDataSource;
  activities: ActivityEvent[] | undefined;

  @ViewChild(MatSort) sort: MatSort | undefined;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (!this.dataSource.sort) {
      this.dataSource.sort = sort;
    }
  }

  constructor(private service: LampService,
    @Inject(MAT_DIALOG_DATA) data, private snackBar: MatSnackBar) {

    this.participant = data.participant;
    this.activity = data.activity;
    this.startDate = data.start;
    this.endDate = data.end;
    this.index = data.index;

    this.generateTable();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort!;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'eventDate': return new Date(item.eventDate);
        default: return item[property];
      }
    };
  }

  generateTable() {
    var lastVal: number = -1;
    this.dataSource.data = [];
    this.loading = true;
    this.showTable = false;
    this.service.getActivityDetailsByParticipant(this.participant.participantId!, this.activity, this.startDate, this.endDate, this.index).subscribe({
      next: activities => {
        this.activities = activities;
        this.dataSource.data = this.activities;
        this.loading = false;
        this.showTable = true;
      },
      error: err => {
        this.loading = false;
        this.showTable = false;
        this.openSnackBar("Error Loading Table Data", "Close");
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }
}
